"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sentry = void 0;
const app_1 = require("@koopajs/app");
const SentryCore = require("@sentry/browser");
const lodash_1 = require("lodash");
class Sentry extends app_1.Plugins.Abstract {
    constructor() {
        super();
        this.key = 'sentry';
        app_1.Bus.onConfigReady(({ sentry }) => {
            if (lodash_1.isEmpty(sentry)) {
                return console.warn('Sentry extension is activated but backend config did not provide a `sentry` value');
            }
            SentryCore.init(sentry);
            this.dispatchSuccess({
                sdkName: SentryCore.SDK_NAME,
                sdkVersion: SentryCore.SDK_VERSION
            });
        });
        app_1.Bus.onUserReady(({ userId }) => {
            SentryCore.setUser({ userId });
        });
    }
}
exports.Sentry = Sentry;
//# sourceMappingURL=index.js.map